/* import React, { useEffect, useState } from "react";
import Boxwithclockimg from "../images/Boxwithclockimg.png";

const PaymentCountdown = ({ initiatedAt, waitingTimeMins = 120, onTimeout }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!initiatedAt || !waitingTimeMins) return;

    const initiatedDate = new Date(initiatedAt);
    const totalSeconds = waitingTimeMins * 60;

    const updateTimer = () => {
      const now = new Date();
      const elapsedSeconds = Math.floor((now - initiatedDate) / 1000);
      const remaining = Math.max(0, totalSeconds - elapsedSeconds);

      setTimeLeft(remaining);

      if (remaining <= 0) {
        onTimeout?.();
      }
    };

    updateTimer(); // run immediately
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [initiatedAt, waitingTimeMins, onTimeout]);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}:${m.toString().padStart(2, "0")}:${s
      .toString()
      .padStart(2, "0")}`;
  };

  if (timeLeft <= 0) return null;

  return (
    <div className="bg-white rounded-md shadow-sm border border-red-200 mx-4 mb-4 p-4 flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <img src={Boxwithclockimg} alt="Timer" className="h-6 w-6" />
        <div>
          <p className="text-sm font-semibold text-[#F84C5C]">Payment Required</p>
          <p className="text-xs text-gray-600">
            Please pay within the timer or you will lose your order & BuildCoins.
          </p>
        </div>
      </div>

      <span className="text-lg font-bold text-[#F84C5C] bg-red-50 px-3 py-1 rounded-lg">
        {formatTime(timeLeft)}
      </span>
    </div>
  );
};

export default PaymentCountdown;
 */

import React, { useEffect, useState } from "react";
import Boxwithclockimg from "../images/Boxwithclockimg.png";

const PaymentCountdown = ({ initiatedAt, waitingTimeMins = 120, onTimeout }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!initiatedAt || !waitingTimeMins) return;

    const initiatedDate = new Date(initiatedAt);
    const totalSeconds = waitingTimeMins * 60;

    const updateTimer = () => {
      const now = new Date();
      const elapsedSeconds = Math.floor((now - initiatedDate) / 1000);
      const remaining = Math.max(0, totalSeconds - elapsedSeconds);

      setTimeLeft(remaining);

      if (remaining <= 0) {
        onTimeout?.();
      }
    };

    updateTimer(); // run immediately
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [initiatedAt, waitingTimeMins, onTimeout]);

/*   const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  }; */

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}:${m.toString().padStart(2, "0")}:${s
      .toString()
      .padStart(2, "0")}`;
  };

  if (timeLeft <= 0) return null;

  const totalSeconds = waitingTimeMins * 60;
  const progressPercent = ((totalSeconds - timeLeft) / totalSeconds) * 100;

  return (
    <div className="bg-white rounded-md shadow-sm border border-red-200 mx-4 mb-4 px-2 py-4 flex items-center justify-between">
      <div className="flex items-center space-x-2">
         <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-8 w-8 text-[#F84C5C]"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
        <div>
          <p className="text-sm font-semibold text-[#F84C5C]">Payment Required</p>
          <p className="text-xs text-gray-600">
  Pay within the timer to avoid <br /> losing your order and BuildCoins.
</p>

        </div>
      </div>

      <div className="flex flex-col items-center space-y-1">
        <span className="text-lg font-bold text-[#F84C5C]">{formatTime(timeLeft)}</span>
        <span className="text-xs text-gray-600">Time remaining</span>
        <div className="w-24 h-2 bg-red-100 rounded-full overflow-hidden mt-1">
          <div
            className="h-2 bg-[#F84C5C] rounded-full transition-all duration-300"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentCountdown;
